import { extractErrorMessage } from '../../../utilities';
import { QUERY_EXECUTION_STATUS, MAX_RETRIES, BASE_MS } from '../common/constants';
import { sleep } from '.';
import logger from '../../../utils/logging';

export const pullDataWithRetryAndTimeout = async (
  index,
  retry = 0,
  client,
  requestPayloads,
  responsePayloads,
  incompleteResponsePayloads,
  onAllPayloadsLoaded,
  onLoadDone,
  onLoadError
) => {
  if (retry <= MAX_RETRIES) {
    await sleep(retry === 0 ? 0 : Math.pow(2, retry) * BASE_MS);
    pullData(
      index,
      retry,
      client,
      requestPayloads,
      responsePayloads,
      incompleteResponsePayloads,
      onAllPayloadsLoaded,
      onLoadDone,
      onLoadError,
      pullDataWithRetryAndTimeout
    );
  } else {
    onLoadError();
  }
};

const pullData = async (
  index,
  retry,
  client,
  requestPayloads,
  responsePayloads,
  incompleteResponsePayloads,
  onAllPayloadsLoaded,
  onLoadDone,
  onLoadError,
  pullDataWithRetryAndTimeout
) => {
  const requestPayload = requestPayloads[index];
  const snapshots = requestPayloads.map((p) => p.snapshot);
  const { queryExecutionId } = incompleteResponsePayloads[index] || {};

  client.pullAccuracyData(
    (response, index, payload, item, retry) =>
      onAccuracyPullSuccess(
        response,
        index,
        payload,
        retry,
        requestPayloads,
        responsePayloads,
        incompleteResponsePayloads,
        client,
        pullDataWithRetryAndTimeout,
        onAllPayloadsLoaded,
        onLoadDone,
        onLoadError
      ),
    (error, retry) =>
      onAccuracyPullFailure(
        error,
        index,
        retry,
        requestPayloads,
        responsePayloads,
        incompleteResponsePayloads,
        client,
        pullDataWithRetryAndTimeout,
        onAllPayloadsLoaded,
        onLoadDone,
        onLoadError
      ),
    requestPayload,
    queryExecutionId,
    snapshots,
    index,
    null,
    retry
  );
};

const onAccuracyPullSuccess = async (
  response,
  index,
  payload,
  retry,
  requestPayloads,
  responsePayloads,
  incompleteResponsePayloads,
  client,
  pullDataWithRetryAndTimeout,
  onAllPayloadsLoaded,
  onLoadDone,
  onLoadError
) => {
  const success = response.queryExecutionStatus === QUERY_EXECUTION_STATUS.COMPLETE;
  responsePayloads[index] = success ? response : null;
  incompleteResponsePayloads[index] = !success ? response : null;

  const allPayloadsLoaded =
    responsePayloads.length === requestPayloads.length &&
    !responsePayloads.includes(null) &&
    !responsePayloads.includes(undefined);
  if (allPayloadsLoaded) {
    onAllPayloadsLoaded({ allPayloadsLoaded });
    const reportType = payload.report.toUpperCase();
    onLoadDone({ reportType });
  } else {
    if (incompleteResponsePayloads[index]) {
      pullDataWithRetryAndTimeout(
        index,
        retry + 1,
        client,
        requestPayloads,
        responsePayloads,
        incompleteResponsePayloads,
        onAllPayloadsLoaded,
        onLoadDone,
        onLoadError
      );
    }
  }
};

const onAccuracyPullFailure = async (
  error,
  index,
  retry,
  requestPayloads,
  responsePayloads,
  incompleteResponsePayloads,
  client,
  pullDataWithRetryAndTimeout,
  onAllPayloadsLoaded,
  onLoadDone,
  onLoadError
) => {
  pullDataWithRetryAndTimeout(
    index,
    retry + 1,
    client,
    requestPayloads,
    responsePayloads,
    incompleteResponsePayloads,
    onAllPayloadsLoaded,
    onLoadDone,
    onLoadError
  );
  extractErrorMessage(error).includes("Unknown column 'base_factor' in 'field list'") ? onLoadError() : '';
  logger.error('Load report failure', error, retry);
};



// WEBPACK FOOTER //
// ./src/components/reports/utils/load_data.js